import Vue from 'vue';
import axios from 'axios';

export default {};

export const sms = {
	install(Vue) {
		Vue.prototype.$sms = {
			sendSms: async function({ number, message }) {
				number = process.env.VUE_APP_SYSTEM_MODE === 'production' ? number : '01077357832';

				message = `[진담헤어] ${message}`;

				const baseUrl = 'https://asia-northeast3-jindamhair.cloudfunctions.net/sendSMS';
				const url = `${baseUrl}?number=${number}&sms=${encodeURIComponent(message)}`;

				try {
					const response = await axios.get(url);
					if (response.status === 200) {
						const received = response.data;
						if (received.result_code === '1') {
							return true;
						}
					} else {
						console.log(`Error: ${response.status}`);
					}
				} catch (error) {
					console.error(`Exception: ${error}`);
				}
				return false;
			},
		};
	},
};

Vue.use(sms);
